export default __webpack_public_path__ + "static/media/cp_geo_kg.58c395a6.svg";